import React from 'react';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaFacebook, FaInstagram, FaLinkedin } from 'react-icons/fa';

const TopInfoBar: React.FC = () => {
  return (
    <div className="bg-gray-50 text-gray-700 text-xs md:text-[13px] font-medium py-1 md:py-1.5 border-b border-gray-200">
      <div className="container mx-auto px-4 md:px-0">
        <div className="flex flex-col md:flex-row justify-between items-center gap-2 md:gap-0">
          {/* Contact Info */}
          <div className="flex flex-col items-center md:items-start lg:flex-row lg:items-center justify-start gap-2 md:gap-4 w-full md:w-auto">
            <div className="flex flex-wrap items-center justify-center md:justify-start gap-4 w-full lg:w-auto">
              <div className="flex items-center space-x-1 whitespace-nowrap">
                <FaPhone className="text-primary" />
                <a href="tel:+919942019000" className="hover:text-primary transition-colors">+91 9942019000</a>
              </div>
              <div className="flex items-center space-x-1 whitespace-nowrap">
                <FaEnvelope className="text-primary" />
                <a href="mailto:hello@mylvtrust.com" className="hover:text-primary transition-colors">hello@mylvtrust.com</a>
              </div>
            </div>

            <div className="flex items-center space-x-2 text-center md:text-left">
              <FaMapMarkerAlt className="text-primary flex-shrink-0" />
              <span className="flex items-center flex-wrap justify-center md:justify-start gap-1">
                <span className="leading-tight text-center md:text-left">
                  58, 59 F-3 DJ Garden Extension, Ramamurthy Road, Selvapuram, Coimbatore-641026,{" "}
                  <span className="whitespace-nowrap">
                    TN
                    <svg className="w-5 h-3 ml-1 inline-block align-middle" viewBox="0 0 24 16" fill="none">
                      <rect width="24" height="5.33" fill="#FF9933" />
                      <rect width="24" height="5.33" y="5.33" fill="white" />
                      <rect width="24" height="5.33" y="10.66" fill="#138808" />
                      <circle cx="12" cy="8" r="1.8" fill="#000080" />
                      <circle cx="12" cy="8" r="2.2" fill="none" stroke="#000080" strokeWidth="0.3" />
                      <path d="M12 6.5 L12.4 7.3 L13.2 7.3 L12.6 7.8 L12.8 8.6 L12 8.1 L11.2 8.6 L11.4 7.8 L10.8 7.3 L11.6 7.3 Z" fill="#000080" />
                    </svg>
                  </span>
                </span>
              </span>
            </div>
          </div>

          {/* Social Icons */}
          <div className="flex space-x-3 items-center">
            <a
              href="https://www.linkedin.com/company/lvtrust"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-primary transition-colors"
              aria-label="LinkedIn"
            >
              <FaLinkedin className="w-4 h-4" />
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61587095211533"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-primary transition-colors"
              aria-label="Facebook"
            >
              <FaFacebook className="w-4 h-4" />
            </a>
            <a
              href="https://www.instagram.com/mylvtrust"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-primary transition-colors"
              aria-label="Instagram"
            >
              <FaInstagram className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );

};

export default TopInfoBar;
